import clsx from 'clsx'
import { ComponentProps, FC, useState } from 'react'
import { Button, DialogTitle, Modal, ModalCenter, Tooltip } from 'src/components'
import { ECampaignSubmissionStatus } from 'src/enums'
import { IconEmojiGreatMatch, IconEmojiNotAMatch, IconEmojiPossibleMatch, IconEmojiToReview } from 'src/icons'
import Style from './style.module.scss'

interface IProps {
  tab?: ECampaignSubmissionStatus
  action?: (status: ECampaignSubmissionStatus) => void
}

export const ModalApplicantBulkActionReview: FC<ComponentProps<typeof Modal> & IProps> = ({ action, tab, ...props }) => {
  const [status, setStatus] = useState<ECampaignSubmissionStatus>()

  return (
    <ModalCenter
      {...props}
      contentStyles={{ width: 424 }}
      contentClass="p-10"
    >
      <div className="fx-column fx-ai-center gap-8">
        <div className="fx-column gap-2 fx-ai-center w-100-p">
          <DialogTitle className="mb-3 fw-500-p">
            Mass Review
          </DialogTitle>

          <div className="fx-column gap-2 w-100-p">
            <div className="txt-center lh-20 txt-black-02">
              Pick a rating for the Applicants you’ve selected
            </div>

            <div className={Style.emojiReview}>
              {tab !== ECampaignSubmissionStatus.GREAT_MATCH && (
                <Tooltip title="This Applicant is great for the role.">
                  <div className={clsx('fx-column fx-ai-center gap-2 p-1 pointer', status === ECampaignSubmissionStatus.GREAT_MATCH && Style.greatMatch)} onClick={() => setStatus(ECampaignSubmissionStatus.GREAT_MATCH)}>
                    <IconEmojiGreatMatch/>
                    <div style={{ minWidth: 'max-content' }} className="fs-12 fw-500 txt-black-02">Great Match</div>
                  </div>
                </Tooltip>
              )}

              {tab !== ECampaignSubmissionStatus.POSSIBLE_MATCH && (
                <Tooltip title="This Applicant might be a fit.">
                  <div className={clsx('fx-column fx-ai-center gap-2 p-1 pointer', status === ECampaignSubmissionStatus.POSSIBLE_MATCH && Style.possibleMatch)} onClick={() => setStatus(ECampaignSubmissionStatus.POSSIBLE_MATCH)}>
                    <IconEmojiPossibleMatch/>
                    <div style={{ minWidth: 'max-content' }} className="fs-12 fw-500 txt-black-02">Possible Match</div>
                  </div>
                </Tooltip>
              )}

              {tab !== ECampaignSubmissionStatus.NOT_A_MATCH && (
                <Tooltip title="This Applicant is not a fit.">
                  <div className={clsx('fx-column fx-ai-center gap-2 p-1 pointer', status === ECampaignSubmissionStatus.NOT_A_MATCH && Style.notAMatch)} onClick={() => setStatus(ECampaignSubmissionStatus.NOT_A_MATCH)}>
                    <IconEmojiNotAMatch/>
                    <div style={{ minWidth: 'max-content' }} className="fs-12 fw-500 txt-black-02">Not a Match</div>
                  </div>
                </Tooltip>
              )}

              {tab !== ECampaignSubmissionStatus.TO_REVIEW && (
                <Tooltip title="Reconsider this Applicant later.">
                  <div className={clsx('fx-column fx-ai-center gap-2 p-1 pointer', status === ECampaignSubmissionStatus.TO_REVIEW && Style.toReview)} onClick={() => setStatus(ECampaignSubmissionStatus.TO_REVIEW)}>
                    <IconEmojiToReview/>
                    <div style={{ minWidth: 'max-content' }} className="fs-12 fw-500 txt-black-02">To Review</div>
                  </div>
                </Tooltip>
              )}
            </div>
          </div>
        </div>

        <div className="fx-column gap-3 w-100-p">
          <Button
            disabled={!status}
            onClick={() => {
              status && action?.(status)
              props.onClose?.()
            }}
          >
            Save
          </Button>
          <Button
            variant="secondary"
            onClick={() => props.onClose?.()}
          >
            Cancel
          </Button>
        </div>
      </div>
    </ModalCenter>
  )
}
